"use client";

import { useEffect, useState } from "react";

// Example: List of local helplines by country (can be expanded or fetched dynamically)
const LOCAL_SUPPORT = [
  {
    country: "United States",
    contact: "SAMHSA National Helpline: 1-800-662-HELP (4357)",
    url: "https://www.samhsa.gov/find-help/national-helpline"
  },
  {
    country: "United Kingdom",
    contact: "Drinkline: 0300 123 1110",
    url: "https://www.nhs.uk/live-well/alcohol-support/"
  },
  {
    country: "India",
    contact: "NIMHANS Alcohol Helpline: 080-46110007",
    url: "https://nimhans.ac.in/"
  },
  {
    country: "Australia",
    contact: "Alcohol Drug Information Service: 1800 250 015",
    url: "https://adf.org.au/help-support/"
  },
  {
    country: "Canada",
    contact: "Helpline: 1-800-668-6868",
    url: "https://www.ccsa.ca/need-help"
  },
];

export default function DynamicHelpCard() {
  const [show, setShow] = useState(false);
  const [support, setSupport] = useState(null);

  useEffect(() => {
    // Try to detect user's country using the browser's locale (client-side only)
    const userLang = navigator.language || navigator.userLanguage;
    let found = null;
    if (userLang.startsWith("en-US")) found = LOCAL_SUPPORT[0];
    else if (userLang.startsWith("en-GB")) found = LOCAL_SUPPORT[1];
    else if (userLang.startsWith("en-IN") || userLang.startsWith("hi")) found = LOCAL_SUPPORT[2];
    else if (userLang.startsWith("en-AU")) found = LOCAL_SUPPORT[3];
    else if (userLang.startsWith("en-CA")) found = LOCAL_SUPPORT[4];
    setSupport(found);
    setTimeout(() => setShow(true), 700); // Slide down after short delay
  }, []);

  if (!show) return null;
  return (
    <div className="fixed left-0 right-0 top-0 z-50 flex justify-center animate-slide-down">
      <div className="bg-yellow-100 border border-yellow-400 rounded-b-lg shadow-lg px-6 py-4 flex flex-col items-center w-full max-w-2xl">
        <span className="font-semibold text-yellow-900 text-lg mb-2">Need Help Quitting Alcohol?</span>
        {support ? (
          <>
            <span className="text-yellow-800 mb-1">Local Support ({support.country}):</span>
            <a href={support.url} target="_blank" rel="noopener noreferrer" className="underline text-blue-700 font-medium">{support.contact}</a>
          </>
        ) : (
          <span className="text-yellow-800">Find local support resources for your country online or consult a healthcare professional.</span>
        )}
        <button
          className="mt-3 px-3 py-1 bg-yellow-300 hover:bg-yellow-400 rounded text-yellow-900 font-semibold transition"
          onClick={() => setShow(false)}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
